import React, { FC } from 'react';
import styles from './DiscountBubble.module.scss';

export interface DiscountBubbleProps {
  bubbleBackgroundColor?: string;
  bubbleBorderColor?: string;
  fontColor?: string;
  label?: string;
}

const DiscountBubble: FC<DiscountBubbleProps> = ({ bubbleBackgroundColor, bubbleBorderColor, fontColor, label }) => {
  const bubbleStyle = {
    backgroundColor: bubbleBackgroundColor,
    borderColor: bubbleBorderColor,
    fontColor,
  };

  return (
    <div className={styles.discountBubble} style={bubbleStyle}>
      <span className={styles.text}>{label}</span>
    </div>
  );
};

export default DiscountBubble;
